import * as React from 'react';
import { generatePath, Link, useParams, useRouteMatch } from 'react-router-dom';

import FrameNav from '@/pages/Module/components/FrameNav';

import {
  ElearningParamType,
  ModuleResourcesRoutes,
  ModuleSetupRoutes,
} from '@/pages/Module/routes';

export type HighlightType = 'setup' | 'resources' | 'slides';

interface EditorLayoutPropsType {
  children: React.ReactNode;
}

const EditorLayout = ({ children }: EditorLayoutPropsType) => {
  const { elearningId } = useParams<ElearningParamType>();

  const linkSetup = generatePath(ModuleSetupRoutes.path, {
    elearningId,
  });
  const linkResources = generatePath(ModuleResourcesRoutes.path, {
    elearningId,
  });

  let highlight: HighlightType = 'slides';
  if (useRouteMatch(ModuleSetupRoutes.path)) highlight = 'setup';
  if (useRouteMatch(ModuleResourcesRoutes.path)) highlight = 'resources';

  return (
    <div className="editor-layout__body">
      <div className="editor-layout__nav">
        <nav className="editor-nav">
          <Link
            to={linkSetup}
            className={`${highlight === 'setup' && 'is-active'}`}
          >
            Setup
          </Link>

          <Link
            to={linkResources}
            className={`${highlight === 'resources' && 'is-active'}`}
          >
            Resources
          </Link>
        </nav>
        <FrameNav />
      </div>
      {children}
    </div>
  );
};

export default EditorLayout;
